import * as React from "react";
import { FunctionComponent, useContext, Fragment } from "react";

//MUI
import Button from "@mui/material/Button";

//Custom Components
import UserContext from "@/components/UserContext/UserContext";

//Types
import { ICardActionButton } from "@/@types/ui/Card";
import { UserContextType } from "@/@types/context/UserContext";

const CardActionButton: FunctionComponent<ICardActionButton> = (props) => {
  const userContext = useContext(UserContext) as UserContextType;
  const { needPermission, startIcon, onClick, variant, ariaLabel, ariaControls, textColor, disabled } = props;

  return (
    <Fragment>
      {needPermission && !userContext.hasAnyPermission(needPermission) ? null : (
        <Button
          color="primary"
          size="medium"
          startIcon={startIcon}
          onClick={onClick}
          variant={variant}
          aria-label={ariaLabel}
          aria-controls={ariaControls}
          sx={{
            color: textColor ? textColor : "primary.dark",
            ml: 10,
            mr: 0
          }}
          disabled={disabled !== undefined ? disabled : false}
        >
          {props.children}
        </Button>
      )}
    </Fragment>
  );
};

export default CardActionButton;
